import { render, staticRenderFns } from "./BackendMenu.vue?vue&type=template&id=121a8c44&scoped=true&"
import script from "./BackendMenu.vue?vue&type=script&lang=js&"
export * from "./BackendMenu.vue?vue&type=script&lang=js&"
import style0 from "./BackendMenu.vue?vue&type=style&index=0&id=121a8c44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121a8c44",
  null
  
)

export default component.exports